import { render } from "./App.vue?vue&type=template&id=a09240f2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=a09240f2&lang=css"

import exportComponent from "/Users/rockroc/Code/project/hogonmr-resource/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__